import { useMemo } from 'react'
import { Box, TypoTooltip } from '@applift/factor'
import { EventPixel, EventPostbackMacro } from '@applift/icons'
import { Conversion } from '../../models/Conversion'

interface ConversionNameCellProps {
  value: Conversion['name']
  conversionType: Conversion['type']
}

export const ConversionNameCell = (props: ConversionNameCellProps) => {
  const { conversionType, value } = props

  const icon = useMemo(() => {
    return conversionType?.toLowerCase() === 'pixel' ? (
      <EventPixel color="primary" fontSize={24} />
    ) : (
      <EventPostbackMacro color="primary" fontSize={24} />
    )
  }, [conversionType])

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', maxWidth: 100 }}>
      <>{icon}</>
      <TypoTooltip
        arrow
        TypgraphyProps={{ gutterBottom: false }}
        sx={{ ml: 8 }}
      >
        {value}
      </TypoTooltip>
    </Box>
  )
}
